import { useConfirmationModal } from '@common/confirmation.hooks';
import { EDesignModificationConfirmationActionType } from '@designModification/designModification.models';
import { useMemo } from 'react';

export const useDesignModificationConfirmationModal = ({
  confirmationActionType,
  onConfirm,
}: {
  confirmationActionType: EDesignModificationConfirmationActionType | undefined;
  onConfirm: () => void;
}) => {
  const content = useMemo(() => {
    switch (confirmationActionType) {
      case EDesignModificationConfirmationActionType.create:
      case EDesignModificationConfirmationActionType.update:
      case EDesignModificationConfirmationActionType.issueToTwcAsSrp:
        return 'Confirm to issue design modification to TWC as SRP?';
      case EDesignModificationConfirmationActionType.issueToTwcAsDesigner:
        return 'Confirm to issue design modification to TWC as designer?';
      case EDesignModificationConfirmationActionType.issueToDesigner:
        return 'Confirm to issue design modification to the designer?';
      case EDesignModificationConfirmationActionType.approveDesigner:
        return (
          <span>
            Please confirm you wish to approve this T3. <br />
            Note:
            <ol>
              <li>
                The Proposed Modification Attachment (if any) uploaded by the site will not be approved or released for
                construction.
              </li>
              <li>
                TWD must upload a Designer Attachment (Completed Modification). This sketch will be released for
                construction along with the T3.
              </li>
              <li>T3 soft chop will be applied to the uploaded Designer Attachment.</li>
              <li>
                <span className="gcl-gems-design-modification-detail-confirmation-danger-text">
                  PDF markup may be lost
                </span>
                , markup should be flattened by printing to a new PDF file.
              </li>
            </ol>
          </span>
        );

      case EDesignModificationConfirmationActionType.issueToChecker:
        return 'Confirm to issue design modification to the checker?';
      case EDesignModificationConfirmationActionType.releaseForConstruction:
        return 'Confirm to release construction?';
      case EDesignModificationConfirmationActionType.approveChecker:
        return 'Confirm to approve design modification?';
      case EDesignModificationConfirmationActionType.approveReviewer:
        return 'Confirm to approve design modification?';
      case EDesignModificationConfirmationActionType.requestEndorsement:
        return 'Confirm to request endorsement?';
      case EDesignModificationConfirmationActionType.cancel:
        return 'Confirm to cancel design modification?';
      case EDesignModificationConfirmationActionType.createRevision:
        return 'Confirm to revise this T3?';
      default:
        return '';
    }
  }, [confirmationActionType]);

  const { renderModal, openPortal } = useConfirmationModal({
    content,
    onConfirm,
  });

  return { renderModal, openPortal };
};
